<div class="overflow-y-auto overflow-x-hidden h-full">
	<app-header-views
		[title]="translateClients.title"
		[textButton]="translateClients.buttonNew"
		[hoverButton]="translateClients.hoverButtonNew"
		(actionButton)="openDialogclient()"
	></app-header-views>
	<app-breadcrumb
		[nameElements]="breadcrumb"
		[home]="homeBreadcrumb"
		(positionBreadcumbd)="selecteBreadCrumbd($event)"
	></app-breadcrumb>
	<div *ngIf="!isClientSelect">
		<div *ngIf="!loading">
			<div class="contet-view-client" *ngIf="clients.length > 0">
				<div class="cards-client" *ngFor="let client of clients | sort : 'name'">
					<div class="card-client">
						<div class="settings" (click)="menu.toggle($event)">
							<mat-icon>settings</mat-icon>
							<p-menu #menu [popup]="true" [model]="client.items"></p-menu>
						</div>
						<img
							class="img-card"
							[src]="client.logo"
							imgNotFound
							alt=""
							(click)="selectClientView(client)"
						/>
					</div>
					<div class="title-card" (click)="selectClientView(client)">
						<span>{{ client.name }} </span>
					</div>
				</div>
			</div>
			<div *ngIf="clients.length === 0" class="content-view-not-clients">
				<div class="not-clients">
					<img src="../../../../assets/icon/line.svg" alt="" />
					<div class="text">
						<span>
							{{ translateClients.notSelecteClient }}
							<span class="button">
								<mat-icon>add</mat-icon>
								<span> {{ translateClients.buttonNew }} </span>
							</span>
						</span>
					</div>
				</div>
			</div>
		</div>
		<div class="w-full justify-center" *ngIf="loading">
			<app-loading-spinner *ngIf="loading"></app-loading-spinner>
		</div>
	</div>
	<div class="contet-view" *ngIf="!!isClientSelect">
		<app-sub-sidebar
			[tamMinWidhtSibSidebar]="210"
			[tamWidhtSibSidebar]="250"
			[back]="!!isClientSelect"
			[add]="!!isClientSelect"
			[textTitle]="translateClients.textModules"
			[search]="searchClient"
			[tamHeightSibSidebar]="196"
			(actionAdd)="openDialogAddModuleClient($event)"
			(searchText)="searchSidebar($event)"
			(actionBack)="selecteBreadCrumbd(homeBreadcrumb)"
		>
			<div class="cards" *ngIf="loading">
				<app-loading-spinner></app-loading-spinner>
			</div>
			<div class="cards" *ngIf="!loading">
				<div *ngIf="clientSelect.module.length > 0">
					<div
						class="card"
						[matTooltip]="ModuleClient.custom_name_module"
						[matTooltipPosition]="'right'"
						*ngFor="
							let ModuleClient of clientSelect.module
								| search : searchClient : 'custom_name_module' : 'name'
						"
						[ngClass]="{
							'card-select': ModuleClient?.custom_name_module === moduleSelect.custom_name_module
						}"
					>
						<div class="settings-client relative w-full flex items-center">
							<div class="w-full cursor-pointer" (click)="selectModuleView(ModuleClient)"></div>
							<mat-icon
								class="icon-material icon-setting"
								(click)="deleteModuleClient(ModuleClient)"
								>delete
							</mat-icon>
						</div>
						<div
							class="flex justify-center items-center h-[100px] cursor-pointer w-full"
							(click)="selectModuleView(ModuleClient)"
						>
						
							<img
								src="{{ ModuleClient.logo }}"
								class="w-[130px] h-[90px] object-contain"
								imgNotFound
							/>
						</div>

						<div class="name" (click)="selectModuleView(ModuleClient)">
							<p
								class="truncate w-[195px]"
								[matTooltip]="ModuleClient.name"
								[matTooltipPosition]="'above'"
							>
								{{ ModuleClient.name }}
							</p>
							<p class="truncate w-[195px]">
								{{ translateClients.cardModule }}: {{ ModuleClient.custom_name_module }}
							</p>
						</div>
					</div>
				</div>
				<div *ngIf="clientSelect.module.length === 0" class="mt-12">
					<div class="not-module">
						<img src="../../../../assets/icon/line.svg" alt="" />
						<div class="text">
							<span>
								{{ translateClients.notFoundModule }}
								<span class="button">
									<mat-icon>add</mat-icon>
									<span> {{ translateClients.buttonNewModule }} </span>
								</span>
							</span>
						</div>
					</div>
				</div>
			</div>
		</app-sub-sidebar>

		<div class="view-selected bg-white">
			<div class="not-selected h-full" *ngIf="!clientSelect.sk">
				<div class="content-not-selected h-full flex items-center flex-col justify-center">
					<img src="../../../../assets/icon/notFile.svg" alt="" />
					<span class="notFount">{{ translateClients.textNotSelected }}</span>
				</div>
			</div>
			<div
				class="selected-client h-full bg-white flex flex-col justify-between"
				*ngIf="isClientSelect"
			>
				<app-view-selected-clients
					class="h-full"
					[loading]="loadingModule"
					[client]="clientSelect"
					[module]="moduleSelect"
					[isModuleSelected]="isModuleSelect"
				></app-view-selected-clients>
			</div>
		</div>
	</div>
</div>
<app-modal-alert
	*ngIf="openAlert"
	[value]="valueModalDelete"
	[elementsDelete]="elementsDelete"
	[nameModal]="'modalAlertDeleteElement'"
	(closeModalAlert)="closeModalAlert($event)"
></app-modal-alert>
